module.exports = __webpack_public_path__ + "static/share-129df701e41d6dc0773a765a491fe790.png";